class EnumValue {
  constructor (key, value, kind) {
    this.key = key
    this.value = value
    this.kind = kind
    this['is' + key] = true
  }

  toJSON () {
    let { key, value } = this
    return { key, value }
  }
}

export class Enum {
  constructor (values) {
    Object.keys(values).forEach((key) => {
      this[key] = new EnumValue(key, values[key], this)
    })
    this._values = values
  }

  parse (raw) {
    let found = null
    Object.keys(this._values).forEach((key) => {
      if (this[key].value === raw) {
        found = this[key] // this._values[key]
      }
    })
    if (found === null) {
      throw Error(`Value ${raw} not found in ${Object.values(this._values)}`)
    }

    return found
  }

  praseSafe (raw, defaultValue) {
    try {
      return this.parse(raw)
    } catch (error) {
      if (!defaultValue) {
        return null
      }
      return defaultValue
    }
  }
}
